import { Controller } from 'stimulus'

export default class extends Controller {
  open(event) {
    const { jobId } = this.element.closest('[data-job-id]').dataset
    const { fieldId, fieldType, bulkUpdateColumn } = event.currentTarget.dataset

    const params = new URLSearchParams()
    if (fieldId) params.set('field_id', fieldId)
    if (bulkUpdateColumn) params.set('column', bulkUpdateColumn)
    if (fieldType) params.set('field_type', fieldType)
    if (jobId) params.set('job_id', jobId)
    params.set('format', 'html')

    fetch(`/jobs/${jobId}/v2_samples/set_multiple?${params}`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-cache'
      }
    })
      .then(res => res.text())
      .then((html) => {
        document.querySelector('#modal .modal-body').innerHTML = html
        document.querySelector('#modal-headline').textContent = 'Bulk Update'
        document.dispatchEvent(new Event('modal:open'))
      })
  }
}
